<template>
    <b-modal
      ref="modal-segmentationadd"
      scrollable
      centered
      button-size="sm"
      size="xl"
      @hidden="hideModal"
      style="max-width: 1140px;"
      >
      <template #modal-title>
        <i class="fas fa-user"></i> ADICIONAR SEGMENTAÇÃO
      </template>
      <SegmentationAdd
        ref="segmentationAdd"
        isModal
        isFromListaInteligente
        @Back="hideModal"
      />
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Fechar'"
            @click="hideModal"
          >
            <i class="fas fa-times-circle"></i>
            <span class="d-md-down-none"> Fechar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </template>

<script>
import SegmentationAdd from '@/views/private/configurations/campaign/campaignlist/components/add/campaignlistadd.vue'

export default {
  name: 'AddNewCampanhaListaModal',
  components: {
    SegmentationAdd
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal () {
      this.$refs['modal-segmentationadd'].show()
      this.onSetShow(true)
    },
    hideModal () {
      this.$refs['modal-segmentationadd'].hide()
      this.onHideModal()
    },
    onSetShow (value) {
      this.$nextTick(() => {
        this.show = value
      })
    },
    onEdit (data) {
      this.showModal()
      this.$nextTick(() => {
        this.$refs['segmentationAdd'].onEdit(data)
      })
    },
    onHideModal () {
      this.onSetShow(false)
      this.$emit('reload')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/AddNewCampanhaListaModal.vue